import { createRootRoute, Outlet } from "@tanstack/react-router";
import React from 'react';
import HeroView from '../views/heroView';
export const Route = createRootRoute({
  component: () => {
    const message = 'Your Lists include the items you added from the collections. You can export the list to download, email, or print the information. You can also share lists that you created with other people by activating a share link.';
    return <>
      <HeroView message={message} />
      <Outlet />
    </>;
  }
});
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}